 <template lang='pug'>
  #GPT.main-page.GPT-color.page-noScroll.pb-0.position-relative.pl-5.pr-3.mb-2
    loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    // 標題行
    v-row#page-head.d-flex.align-center.justify-md-space-between(style='max-height: 52px;')
      v-col.d-flex.align-center.px-0.pb-0.pb-md-4(cols='4' md='6' )
        span.ml-2.mr-6(style='font-weight: 700; font-size: 28px;') {{$t('GPT_MENU.USER_ANALYSIS')}}
    // 對話分析卡片
    #page-inner.scroll-x.md-6.pb-0
      .knowledge_height(v-if='!loading')
        v-row.mb-1
          v-col(cols='6' md='6').pl-2
            v-container.upgpt-container(max-content)
              v-row.d-flex.align-center.justify-start.pt-2.ma-0.mb-4(style="margin-left:11px; max-width: 100%;")
                //回覆
                v-col.pl-0.pt-0.UX-usage-analysis-card.mr-2(class="mt-1" cols="6")
                      // icon + 標題
                      v-row.ma-0
                        v-card-title.pa-0.ml-6.mt-2.d-flex.align-center(style="height:38px;")
                          div.pa-0.ma-0.d-flex.align-center.justify-start
                            v-img(id='rounded-card' src="../assets/images/Answer.svg" class="white--text align-end"  width="36px" height="36px" style="margin:6px 6px 4px 0px;")
                            p.ma-0.UX-usage-analysis-card-title {{$t('GPT_USER_ANALYSIS.ANSWER')}}
                      v-row.d-flex.align-end.justify-end.ma-0.mt-4.justify-content-end(style="height:53px;")
                        v-col.pa-0.ma-0.align-center(cols="6" style="height:53px; max-width:114px")
                          p.ma-0.UX-usage-analysis-card-statistic-title-en.mb-1 {{$t('GPT_USER_ANALYSIS.LAST_7_DAYS')}}
                          v-row.align-end.d-flex.mr-8
                            p.ma-0.UX-usage-analysis-card-statistic-num {{this.total_statistics.total_questions}}
                            //p.ma-0.ml-1.UX-usage-analysis-card-statistic-title-en  {{$t('GPT_USER_ANALYSIS.RECORDS')}}
                //有幫助
                v-col.pl-0.pt-0.UX-usage-analysis-card(class="mt-1" cols="6")
                      // icon + 標題
                      v-row.ma-0
                        v-col(cols ="6").pa-0
                          v-card-title.pa-0.ml-6.mt-2.d-flex.align-center(style="height:38px; width:96px;")
                            div.pa-0.ma-0.d-flex.align-center.justify-start
                              v-img(id='rounded-card' src="../assets/images/good.svg" class="white--text align-end"  width="36px" height="36px" style="margin:6px 6px 4px 0px;")
                              p.ma-0.UX-usage-analysis-card-title {{$t('GPT_USER_ANALYSIS.HELPFUL')}}
                        v-col(cols ="6").pa-0
                          v-card-title.pa-0.ml-4.mt-2.d-flex.align-center(style="height:38px; width:96px;")
                            div.pa-0.ma-0.d-flex.align-center.justify-start
                              v-img(id='rounded-card' src="../assets/images/bad.svg" class="white--text align-end"  width="36px" height="36px" style="margin:6px 6px 4px 0px;")
                              p.ma-0.UX-usage-analysis-card-title {{$t('GPT_USER_ANALYSIS.UNHELPFUL')}}
                      v-row.d-flex.align-center.ma-0.ml-6.mt-3(style="height:53px;")
                        v-col(cols="6").pa-0.ma-0.align-center
                          v-row.align-end.d-flex
                              p.ma-0.UX-usage-analysis-card-statistic-num {{this.total_statistics.helpful_questions}}
                              //p.ma-0.ml-1.UX-usage-analysis-card-statistic-title-en  {{$t('GPT_USER_ANALYSIS.RECORDS')}}
                        v-col(cols="6").pa-0.ma-0.align-center
                          v-row.align-end.d-flex
                              p.ma-0.UX-usage-analysis-card-statistic-num {{this.total_statistics.unhelpful_questions}}
                              //p.ma-0.ml-1.UX-usage-analysis-card-statistic-title-en  {{$t('GPT_USER_ANALYSIS.RECORDS')}}
              v-row.d-flex.align-center.justify-start(style="margin-left:11px;").ma-0
                //關聯度
                v-col.pl-0.pt-0.UX-usage-analysis-card.mr-2(class="mt-1" cols="6")
                      // icon + 標題
                      v-row.ma-0
                        v-card-title.pa-0.ml-6.mt-2.d-flex.align-center(style="height:38px; width:96px;")
                          div.pa-0.ma-0.d-flex.align-center.justify-start
                            v-img(id='rounded-card' src="../assets/images/relevance.svg" class="white--text align-end"  width="36px" height="36px" style="margin:6px 6px 4px 0px;")
                            p.ma-0.UX-usage-analysis-card-title {{$t('GPT_USER_ANALYSIS.RELEVANCY')}}

                      v-row.d-flex.align-end.justify-end.ma-0.ml-6(style="height:53px;")
                        v-col(cols="6").pa-0.ma-0.align-center
                          p.ma-0.UX-usage-analysis-card-statistic-title-en.mb-1 {{$t('GPT_USER_ANALYSIS.RELEVANCY_H')}}
                          v-row.align-end.d-flex
                            p.ma-0.UX-usage-analysis-card-statistic-num {{this.total_statistics.relevance_questions}}
                            //p.ma-0.ml-1.UX-usage-analysis-card-statistic-title-en  {{$t('GPT_USER_ANALYSIS.RECORDS')}}
                        v-col(cols="6").pa-0.ma-0.align-center
                          p.ma-0.UX-usage-analysis-card-statistic-title-en.mb-1 {{$t('GPT_USER_ANALYSIS.RELEVANCY_L')}}
                          v-row.align-end.d-flex
                            p.ma-0.UX-usage-analysis-card-statistic-num {{this.total_statistics.irrelevance_questions}}
                            //p.ma-0.ml-1.UX-usage-analysis-card-statistic-title-en  {{$t('GPT_USER_ANALYSIS.RECORDS')}}
                //準確度
                v-col.pl-0.pt-0.UX-usage-analysis-card(class="mt-1" cols="6")
                      // icon + 標題
                      v-row().ma-0
                        v-card-title.pa-0.ml-6.mt-2.d-flex.align-center(style="height:38px; width:96px;")
                          div.pa-0.ma-0.d-flex.align-center.justify-start
                            v-img(id='rounded-card' src="../assets/images/accuracy.svg" class="white--text align-end"  width="36px" height="36px" style="margin:6px 6px 4px 0px;")
                            p.ma-0.UX-usage-analysis-card-title {{$t('GPT_USER_ANALYSIS.ACCURACY')}}

                      v-row.d-flex.align-end.justify-end.ma-0.ml-6(style="height:53px;")

                        v-col(cols="6").pa-0.ma-0.align-center
                          p.ma-0.UX-usage-analysis-card-statistic-title-en.mb-1 {{$t('GPT_USER_ANALYSIS.ACCURACY_H')}}
                          v-row.align-end.d-flex
                            p.ma-0.UX-usage-analysis-card-statistic-num {{this.total_statistics.accuracy_questions}}
                            //p.ma-0.ml-1.UX-usage-analysis-card-statistic-title-en  {{$t('GPT_USER_ANALYSIS.RECORDS')}}
                        v-col(cols="6").pa-0.ma-0.align-center
                          p.ma-0.UX-usage-analysis-card-statistic-title-en.mb-1 {{$t('GPT_USER_ANALYSIS.ACCURACY_L')}}
                          v-row.align-end.d-flex
                            p.ma-0.UX-usage-analysis-card-statistic-num {{this.total_statistics.inaccuracy_questions}}
                            //p.ma-0.ml-5.UX-usage-analysis-card-statistic-title-en  {{$t('GPT_USER_ANALYSIS.RECORDS')}}
          //回覆總數
          v-col(cols='6' md='6').pa-0.pt-7
            v-row.d-flex.align-center.justify-start.pt-2
              v-card.UX-usage-analysis-bar-card(style=" border-radius: 16px !important;")
                v-row.ma-0.ml-3.mb-3.mr-3.mt-3(style="height:15%")
                      v-col(cols="4").d-flex.pa-0
                          v-img(id='rounded-card' src="../assets/images/total_reply.svg" class="white--text align-end"  max-width="36px" max-height="36px" style="margin:6px 6px 4px 0px;")
                          h3.mb-0
                            v-col(cols="12").pa-0.mt-2
                              .UX-usage-analysis-card-Reply-title {{ $t('GPT_USER_ANALYSIS.TOTAL_ANSWER') }}
                      v-col(cols="4").spacer
                      v-col(cols="4" ).pa-0.mt-6
                            .UX-usage-analysis-card-annotation {{ Last7DaysLabel }}
                v-row.ma-0.ml-3.mr-5(style="max-height:75%")
                  bar-chart(
                    v-if="!chartLoading"
                    style="width:100%; max-height:185px;"
                    :chart-data="chartData"
                    :options="chartOptions"
                  )
                div.ma-0.mt-3.pa-0.d-flex.align-center.justify-space-between
        v-row.ma-0.pa-0.d-flex.justify-start
          v-col(cols='9').pa-0.pt-7
            v-row.ma-0.pa-0.d-flex.justify-start
              v-col(cols='2' style="max-width:182px").px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.DATE')}}
                v-select.bg-white.my-chips-select(v-model='selected_date_type' height='30' my-chip dense chips outlined clearable :placeholder='$t("GPT_USER_ANALYSIS.DATE")' :items='date_cate' item-value='date' item-text='name')
                  template(v-slot:selection="{ item, index }")
                    v-chip(v-if="index === 0")
                      span {{ item.name }}
              v-col(cols='4' v-if="selected_date_type === 4" ).px-0.ml-2
                template(v-if="selected_date_type === 4")
                  v-menu(
                    min-width='496px'
                    ref="menu"
                    :close-on-content-click="false"
                    transition="scroll-y-transition"
                    offset-y
                  )
                    template(v-slot:activator="{ on, attrs }")
                      v-text-field.pt-0(
                        v-model='selectDateText'
                        :title='selectDateText'
                        v-bind="attrs"
                        v-on="on"
                        flat
                        dense
                        outlined
                        background-color="white"
                        prepend-inner-icon='mdi-calendar-multiple'
                      )
                    date-picker(
                      v-model='selectDate'
                      type="date"
                      range
                      inline
                      :showSecond='false'
                      value-type='format'
                      format='YYYY-MM-DD'
                      @change="dateChange($event)"
                    )
              v-col(cols='3').px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.CATEGORY')}}
                v-select.bg-white.my-chips-select(v-model='selected_topic' height='10' multiple my-chip dense chips outlined clearable :placeholder='$t("GPT_USER_ANALYSIS.CATEGORY")' :items='topic_list' item-value='id' item-text='name')
                  template(v-slot:prepend-item)
                    v-list-item(ripple @mousedown.prevent @click="toggle_topic")
                      v-list-item-action
                        v-icon(:color="selected_topic.length > 0 ? 'indigo darken-4' : ''") {{ icon(selected_topic, topic_list) }}
                      v-list-item-content
                        v-list-item-title {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    v-divider(class="mt-2")
                  template(v-slot:selection="{ item, index }")
                    //- 如果有全選、只顯示 All chip
                    v-chip(v-if="likeAll(selected_topic,topic_list) && index === 0 ")
                      span {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    template(v-else)
                      v-chip(v-if="index === 0")
                        span {{ item }}
                      span(v-if="index === 1 && !likeAll(selected_topic, topic_list) " class="grey--text text-caption" style="font-size: 8px;") +{{ selected_topic.length - 1 }}

              v-col(cols='3').px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.AVG_RELEVANCY')}}
                v-select.bg-white.my-chips-select(v-model='selected_relevance' height='30' multiple chips dense outlined clearable :placeholder='$t("GPT_USER_ANALYSIS.AVG_RELEVANCY")' :items='level_select' item-value='level' item-text='name')
                  template(v-slot:prepend-item)
                    v-list-item(ripple @mousedown.prevent @click="toggle_relevance")
                      v-list-item-action
                        v-icon(:color="selected_relevance.length > 0 ? 'indigo darken-4' : ''") {{ icon(selected_relevance, level_select) }}
                      v-list-item-content
                        v-list-item-title {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    v-divider(class="mt-2")
                  template(v-slot:selection="{ item, index }")
                    //- 如果有全選、只顯示 All chip
                    v-chip(v-if="likeAll(selected_relevance,level_select) && index === 0 ")
                      span {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    template(v-else)
                      v-chip(v-if="index === 0")
                        span {{ item.name }}
                      span(v-if="index === 1 && !likeAll(selected_relevance, level_select) " class="grey--text text-caption" style="font-size: 8px;") +{{ selected_relevance.length - 1 }}

              v-col(cols='3').px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.AVG_ACCURACY')}}
                v-select.bg-white.my-chips-select(v-model='selected_accuracy' height='30' multiple chips dense outlined clearable :placeholder='$t("GPT_USER_ANALYSIS.AVG_ACCURACY")' :items='level_select' item-value='level' item-text='name')
                  template(v-slot:prepend-item)
                    v-list-item(ripple @mousedown.prevent @click="toggle_accuracy")
                      v-list-item-action
                        v-icon(:color="selected_accuracy.length > 0 ? 'indigo darken-4' : ''") {{ icon(selected_accuracy, level_select) }}
                      v-list-item-content
                        v-list-item-title {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    v-divider(class="mt-2")
                  template(v-slot:selection="{ item, index }")
                    //- 如果有全選、只顯示 All chip
                    v-chip(v-if="likeAll(selected_accuracy,level_select) && index === 0 ")
                      span {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    template(v-else)
                      v-chip(v-if="index === 0")
                        span {{ item.name }}
                      span(v-if="index === 1 && !likeAll(selected_accuracy, level_select) " class="grey--text text-caption" style="font-size: 8px;") +{{ selected_accuracy.length - 1 }}
          v-col(cols="3").pa-0.pt-7
            v-row.ma-0.pa-0.d-flex.justify-start
              // 啟動篩選按鈕
              v-col(cols='3').px-0.ml-3.mr-3
                v-btn.white--text(@click='act_search' height='40' :ripple='false' color='#14C6DE' depressed)
                  v-img.mr-1(src="../assets/images/search_btn_icon.png" max-height="18" max-width="18")
                  span(style='font-weight: 600; font-size: 16px;') {{$t('GENERAL.SEARCH')}}
              // 重置選擇按鈕
              v-col(cols='1').px-0.ml-0
                v-btn(text height='40' @click='refresh')
                  v-img.mr-1(src="../assets/images/refresh.png" max-height="16" max-width="16")
                  span(style="font-family: 'Segoe UI'; font-weight: 700; font-size: 16px; color: #14C6DE;") {{$t('GENERAL.REFRESH')}}
        v-container.thread-analysis-container(max-content)
          v-data-table.dashboard-table.rounded-card.px-3.elevation-2.ml-2.mt-0(
            style='text-align:start;'
            item-key="topic"
            :headers="fieldsHeader",
            :header-props="{sortIcon: 'mdi mdi-arrow-up', style: 'text-align:left !important;'}",
            :items="topics_stat",
            :items-per-page="itemPerPage",
            :page.sync="page",
            @page-count="pageCount = $event",
            multi-sort
            fixed-header,
            hide-default-footer="hide-default-footer",
            height='585px'
            :loading='loading'
            loading-text='Loading . . .'
            @click:row="toDetail($event.topic)"
          )
            template(v-slot:item.topic="{ item }")
              .ellipsis(:title='item.topic'  class="UX-analysis-item")
                span {{ item.topic }}

            template(v-slot:item.total_questions="{ item }")
              .ellipsis(:title='item.total_questions' class="UX-analysis-item")
                span {{ item.total_questions }}

            template(v-slot:item.help_unhelp="{ item }")
              .ellipsis(:title="`${item.helpful_feedback_count} / ${item.unhelpful_feedback_count}` " class="UX-analysis-item")
                span {{ item.helpful_feedback_count }} / {{ item.unhelpful_feedback_count }}

            template(v-slot:item.avg_relevance="{ item }")
              .ellipsis(:title='(item.avg_relevance * 20).toFixed(2)' class="UX-analysis-item")
                span {{ (item.avg_relevance*20).toFixed(0) }}%

            template(v-slot:item.avg_accuracy="{ item }")
              .ellipsis(:title='(item.avg_accuracy * 20).toFixed(2)' class="UX-analysis-item")
                span {{ (item.avg_accuracy * 20).toFixed(0) }}%

            template(v-slot:body.append="{ loading }" v-if="!loading")
              tr
                td(:colspan="fieldsHeader.length")
                  .v-row.d-flex.align-center.justify-center
                    .v-col-auto.d-flex.align-center
                      //span.mr-2.UX-analysis-item Rows per page:
                      //v-select(
                      //  v-model="itemPerPage"
                      //  :items="[5, 10, 15, 20, 25, 50]"
                      //  dense
                      //  hide-details
                      //  style="width: 60px;"
                      //  @change="page = 1"
                      //)
                      //.d-flex.align-center.grey--text.text--darken-1.ml-5.mr-3
                      //  span.UX-analysis-item {{ pageRangeText }}
                      v-pagination(
                        v-model='page'
                        :length='pageCount'
                        circle
                        :total-visible="10"
                        next-icon="mdi-menu-right"
                        prev-icon="mdi-menu-left"
                      )

    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')

</template>

<script>
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import addDialog from "@/components/GPT_Dialog/Knowledge/addKnowledge";
import i18n from '/common/plugins/vue-i18n.js';
import barChart from '../assets/script/barChart';
import KnowledgeLibraryService from "../services/KnowledgeLibraryService";
import PersonalSettingService from "@/services/PersonalSettingService";
import UpGPTDataService from "../services/UpGPTDataService";
import DatePicker from 'vue2-datepicker';

export default {
  components: {
    barChart,
    loadingOverlay,
    messageDialog,
    successDialog,
    errorDialog,
    addDialog,
    DatePicker,
  },
  data() {
    return {
      // other
      loading:false,
      isDelete:false,
      // Dialog
      addDialog:false,
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      // Data
      Knowledges_list:[],
      filter_knowledges_list:[],
      botList:[],
      deleteId:null,
      bot_background_colors: ['#9ACFFF', '#F6C2C2', '#DEC5F6', '#9ACFFF', '#F6C2C2', '#DEC5F6' ],
      user_list:[],
      libname_search:'',
      fieldsHeader: [
        { text: i18n.t('GPT_USER_ANALYSIS.CATEGORY'), value: "topic", align: "left", width: '20%', sortable: true, class:'UX-analysis-header ',headerClass:'text-left' },
        { text: i18n.t('GPT_USER_ANALYSIS.TOTAL_ANSWER'), value: "total_questions", align: "left", width: '20%', sortable: true, class:'UX-analysis-header ', headerClass:'text-left'},
        { text: i18n.t('GPT_USER_ANALYSIS.HELP_UNHELP'), value: "help_unhelp", align: "left", width: '20%', sortable: true, class:'UX-analysis-header ', headerClass:'text-left'},
        { text: i18n.t('GPT_USER_ANALYSIS.AVG_RELEVANCY'), value: "avg_relevance", align: "left", width: '20%', sortable: true, class:'UX-analysis-header ', headerClass:'text-left'},
        { text: i18n.t('GPT_USER_ANALYSIS.AVG_ACCURACY'), value: "avg_accuracy", align: "left", width: '20%', sortable: true,  class:'UX-analysis-header ', headerClass:'text-left'},
      ],
      //UserAnalysis
      topic_list:[],
      topics_stat:[],
      total_statistics:{},
      week_statics:[],
      chartLoading: false,
      page: 1,
      pageCount: 1,
      itemPerPage: 10,
      date_cate:[{date:0,name:i18n.t('GPT_USER_ANALYSIS.TODAY')},{date:1,name:i18n.t('GPT_USER_ANALYSIS.THIS_WEEK')},{date:3,name:i18n.t('GPT_USER_ANALYSIS.LAST_7_DAYS')},{date:2,name:i18n.t('GPT_USER_ANALYSIS.THIS_MONTH')},{date:4,name:i18n.t('GPT_USER_ANALYSIS.DATE_RANGE')}],
      level_select:[{level:0,name:"0~20%"},{level:1,name:"21~40%"}, {level:2,name:"41~60%"},{level:3,name:"61~80%"},{level:4,name:"81~100%"}],
      selected_date_type: 3,
      select_start_date: '',
      select_end_date: '',
      selectDate:'',
      selectDateText:'',
      selected_topic:[],
      selected_relevance:[0,1,2,3,4],
      selected_accuracy:[0,1,2,3,4],
      relevance_para:null,
      accuracy_para:null,
      like_all_topic:false,
      like_all_relevance:false,
      like_all_accuracy:false,
      startDate: null,
      endDate: null,
    };
  },
  async created() {
    this.loading = true;
    this.getTotalStatistics();
    await this.get_all_topic();
    this.selected_topic = this.topic_list;
    await this.getListData();
    await PersonalSettingService.getUserDetail().then(response => {
      if (response.data.userList.length > 0) {
        let temp_arr = [];
        let temp_data = {};
        let user_data = response.data.userList;
        user_data.filter(el => {
          temp_data = {};
          if(el.is_active == true){
            temp_data['id'] = el.id;
            temp_data['name'] = el.last_name+' '+el.first_name;
            temp_arr.push(temp_data);
          }
        });
        this.user_list = temp_arr
      }
    })
    .catch((response) => {
        this.showErrorDialog(response);
    });
    this.loading = false;
  },
  destroyed() {
  },
  computed:{

    chartData() {
      // 直接從統計數據中提取日期和計數
      const dateLabels = this.week_statics.map(item => `${item.Month}/${item.Day}`);
      const counts = this.week_statics.map(item => item.Count);

      return {
        labels: dateLabels,
        datasets: [
          {
            label: i18n.t('GPT_USER_ANALYSIS.TOTAL_ANSWER'),
            backgroundColor: '#4ac6de',
            data: counts
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              offsetGridLines: false,
              display: true,
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontStyle: 'bold',
              stepSize: 1,
              callback: function(value) {
                if (Number.isInteger(value)) { return value; }
              }
            }
          }]
        },
        legend: {
          display: false
        }
      };
    },
    pageRangeText() {
      const start = (this.page - 1) * this.itemPerPage + 1;
      const end = Math.min(start + this.itemPerPage - 1, this.topics_stat.length);
      const total = this.topics_stat.length;
      return `${start}-${end} of ${total}`;
    },
    Last7DaysLabel() {
           if (!this.total_statistics.statistics.length) return 'Last 7 days';

          // 取第一天和最後一天
          const start = this.total_statistics.statistics[0];
          const end = this.total_statistics.statistics[6];

          // 格式化 4/7 這種格式
          function format(month, day) {
            return `${month}/${day}`;
          }
          return ` ${i18n.t('GPT_USER_ANALYSIS.LAST_7_DAYS')} (${format(start.Month, start.Day)}-${format(end.Month, end.Day)})`;
    }
  },
  methods: {
    async getListData(){
      // Prepare request data
      const requestData = {
        ...(this.startDate != null && { start_date: this.startDate }),
        ...(this.endDate != null && { end_date: this.endDate }),
        topic: this.selected_topic || this.topic_list,
        ...(this.selected_relevance!= null && {relevance:this.selected_relevance}),
        ...(this.selected_accuracy!= null && {accuracy:this.selected_accuracy})
      };
      try {
        // Create a new service method in a service file (e.g., UserAnalysisService)
        // For now, we'll use an existing service as a placeholder
        console.log(requestData)
        const response = await UpGPTDataService.get_topics_statistics_by_topic(requestData);

        // Process the response data
        this.topics_stat = response.data;

        // Additional processing if needed
        // this.topics_stat.forEach(el => {
        //   // You can add any additional properties or transformations here
        //   el.help_unhelp = `${el.helpful_feedback_count} / ${el.unhelpful_feedback_count}`;
        // });

        // Update any other data properties as needed
        this.loading = false;
      } catch (error) {
        this.showErrorDialog(error);
        this.loading = false;
      }
    },
    async getTotalStatistics() {
      await  UpGPTDataService.get_total_statistics().then((response)=>{
        this.total_statistics = JSON.parse(JSON.stringify(response.data))
        this.week_statics = this.total_statistics.statistics
      })
    },
    dateChange(val){
      this.selectDateText = val.join(" ~ ");
      this.select_start_date = val[0];
      this.select_end_date = val[1];
    },
    async change_formate(){// Relevance Percentage
      const relevance_questions = this.total_statistics.relevance_questions;
      const irrelevance_questions = this.total_statistics.irrelevance_questions;
      this.total_statistics.relevancePercentage = (relevance_questions + irrelevance_questions) > 0
        ? (relevance_questions / (relevance_questions + irrelevance_questions) * 100).toFixed(1)
        : 0;
      // Accuracy Percentage
      const accuracy_questions = this.total_statistics.accuracy_questions;
      const inaccuracy_questions = this.total_statistics.inaccuracy_questions;
      this.total_statistics.accuracyPercentage = (accuracy_questions + inaccuracy_questions) > 0
        ? (accuracy_questions / (accuracy_questions + inaccuracy_questions) * 20).toFixed(1)
        : 0;
    },
    async get_all_topic(){
      await  UpGPTDataService.get_all_distinct_topic().then((response)=>{
        this.topic_list = response.data;
        console.log("Topic list : ", this.topics_stat);
      })
    },
    toDetail(name) {
      if (!this.isDelete) {
        let query = {};

        if (this.selected_date_type == 4) {
          query = {
            date_type: this.selected_date_type,
            start_date: this.select_start_date,
            end_date: this.select_end_date
          };
        } else {
          query = {
            date_type: this.selected_date_type
          };
        }
        this.$router.push({
          path: this.$route.path + '/' + name,
          query: query
        });
      }
    },
    toggle_topic() {
      this.$nextTick(() => {
        if (this.likeAll(this.selected_topic, this.topic_list)) {
          this.selected_topic = []
        } else {
          this.selected_topic = this.topic_list.slice()
        }
      })
    },
    toggle_relevance() {
      this.$nextTick(() => {
        if (this.likeAll(this.selected_relevance, this.level_select)) {
          this.selected_relevance = []
        } else {
          this.selected_relevance = this.level_select.map(item => item.level)
        }
      })
    },
    toggle_accuracy() {
      this.$nextTick(() => {
        if (this.likeAll(this.selected_accuracy, this.level_select)) {
          this.selected_accuracy = []
        } else {
          this.selected_accuracy = this.level_select.map(item => item.level)
        }
      })
    },
    likeAll(selected,item){
      return selected.length === item.length
    },
    likesome(seleected,item){
      return seleected.length > 0 && !this.likeAll(seleected,item)
    },
    icon(selected,item){
      if (this.likeAll(selected,item)){
        return 'mdi-close-box'
      }
      else if(this.likesome(selected,item)){ return 'mdi-minus-box'}
      else{
        return 'mdi-checkbox-blank-outline'
      }
    },
    getDateRange(type) {
      const now = new Date();

      let start_date, end_date;
      function pad(n) { return n.toString().padStart(2, '0'); }
      function format(dateObj, h = '00', m = '00', s = '00') {
        // 轉換成 yyyy-mm-ddThh:mm:ss
        return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())}T${h}:${m}:${s}`;
      }
      if (type === 0) {
        // 今天
        start_date = format(now, '00', '00', '00');
        end_date = format(now, '23', '59', '59');

      }
      else if (type === 1) {
        // 這週
        const day = now.getDay(); // 0(日)~6(六)
        const mondayOffset = day === 0 ? -6 : 1 - day; // 本週一
        const sundayOffset = day === 0 ? 0 : 7 - day; // 本週日
        // 週一
        const first = new Date(now);
        first.setDate(first.getDate() + mondayOffset);
        // 週日
        const last = new Date(now);
        last.setDate(last.getDate() + sundayOffset);

        start_date = format(first, '00', '00', '00');
        end_date = format(last, '23', '59', '59');

      } else if (type === 2) {
        // 這月
        // 月初
        const first = new Date(now.getFullYear(), now.getMonth(), 1);
        const last = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 下個月的第0天=本月最後一天

        start_date = format(first, '00', '00', '00');
        end_date = format(last, '23', '59', '59');
      } else if (type === 3) {
        // 過去七天
        const now = new Date();

        // 過去七天：End=今天, Start=今天-6天
        const end = new Date(now);         // 今天
        const start = new Date(now);
        start.setDate(start.getDate() - 6);

        start_date = format(start, '00', '00', '00');   // 這6天前的 00:00:00
        end_date = format(end, '23', '59', '59');       // 今天的 23:59:59

      }else if (type === 4) {
        // 自訂
        const start = new Date(this.select_start_date)
        const end = new Date(this.select_end_date)
        start_date = format(start, '00', '00', '00');   // 這6天前的 00:00:00
        end_date = format(end, '23', '59', '59');       // 今天的 23:59:59

      } else {
        throw new Error('未知type');
      }

      return {start_date, end_date };
    },
    get_rele_accur_para(selected){
      return selected.map(val => ({ min: val, max: val }));
    },
    // Dialog Area ----------------------------------------- [Start]
    showAddDialog() {
      this.addDialog = true;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog(val) {
      if(val && this.isDelete){
          await KnowledgeLibraryService.delete(this.deleteId).then(()=>{
            this.Knowledges_list = this.Knowledges_list.filter(el=>el.id != this.deleteId)
            this.act_search();
        })
      }
      this.isDelete = false;
      this.deleteId = null,
      this.messageDialog = false;
    },
    async act_search() {
      if (this.selected_date_type === 4 && (!this.select_start_date || !this.select_end_date)) {
        this.showErrorDialog(this.$t('GPT_USER_ANALYSIS.SELECT_DATE_RANGE_ERROR'));
      return;
      }
      const { start_date, end_date } =  this.getDateRange(this.selected_date_type);
      this.startDate = start_date;
      this.endDate = end_date;
      await this.getListData();
    },
    async refresh(){
      this.selected_date_type = 3;
      this.selected_topic = this.topic_list;
      this.selected_relevance = [0,1,2,3,4];
      this.selected_accuracy = [0,1,2,3,4];
      this.act_search();
    },
  },
  watch:{
    "messageDialog":function(){
      if(!this.messageDialog){
        this.isDelete = false;
      }
    },
    "libname_search":function(){
      this.act_search();
    },
  }

};
</script>
<style scoped>
:deep(.v-data-table thead th) {
  border-bottom: 10px solid #dc3545;
}
</style>